function OutletSpinner() {
  return (
    <div className="flex justify-center items-center translate-y-8">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-thirdgray"></div>
    </div>
  );
}

export default OutletSpinner;
